import LegalLayout from '../components/LegalLayout';

const Article = ({ num, title, children }: { num: string; title: string; children: React.ReactNode }) => (
  <article className="mb-10">
    <h2 className="text-lg font-bold text-[#C9A227] mb-4 flex items-center gap-3">
      <span className="text-xs font-mono text-white/20 w-8">ART.</span>
      <span>{num} — {title}</span>
    </h2>
    <div className="pl-11 space-y-3 text-white/70 text-sm leading-relaxed">
      {children}
    </div>
  </article>
);

export default function CgvPage() {
  return (
    <LegalLayout
      title="Conditions Générales de Vente"
      subtitle="En vigueur au 27 janvier 2026 — Conformes au Code de la consommation et au droit français"
    >
      <div className="bg-[#0D1228] border border-white/[0.07] rounded-lg p-6 mb-10 text-xs text-white/40 flex items-start gap-3">
        <i className="ri-file-text-line text-[#C9A227] text-base mt-0.5 shrink-0"></i>
        <p>
          Les présentes Conditions Générales de Vente (CGV) régissent les relations contractuelles entre Madame Aurélie Pinto, micro-entrepreneur exerçant sous le nom commercial <strong className="text-white/60">AD.NOVA.PRO</strong>, et toute personne physique (ci-après « le Client ») procédant à un achat de service sur le site <strong className="text-white/60">lereseausportif.com</strong>. Tout achat implique l&apos;acceptation pleine et entière des présentes CGV.
        </p>
      </div>

      <Article num="1" title="Identification du vendeur">
        <div className="bg-[#080C1E] rounded-lg border border-white/[0.05] p-5 space-y-2 text-xs">
          <div className="flex gap-4"><span className="text-white/30 w-40 shrink-0">Nom</span><span>MADAME AURELIE PINTO</span></div>
          <div className="flex gap-4"><span className="text-white/30 w-40 shrink-0">Statut</span><span>Micro-entrepreneur</span></div>
          <div className="flex gap-4"><span className="text-white/30 w-40 shrink-0">Nom commercial</span><span>AD.NOVA.PRO</span></div>
          <div className="flex gap-4"><span className="text-white/30 w-40 shrink-0">SIRET</span><span>100 385 756 00018</span></div>
          <div className="flex gap-4"><span className="text-white/30 w-40 shrink-0">Code NAF</span><span>7022Z</span></div>
          <div className="flex gap-4"><span className="text-white/30 w-40 shrink-0">Adresse</span><span>2 allée des jardins de Courrejean, 33140 Villenave-d&apos;Ornon</span></div>
          <div className="flex gap-4"><span className="text-white/30 w-40 shrink-0">Téléphone</span><span>06 14 12 68 69</span></div>
          <div className="flex gap-4"><span className="text-white/30 w-40 shrink-0">Email</span><span>ad.nova.pro33@gmail.com</span></div>
          <div className="flex gap-4"><span className="text-white/30 w-40 shrink-0">Site</span><span>lereseausportif.com</span></div>
        </div>
      </Article>

      <Article num="2" title="Champ d'application">
        <p>
          Les présentes CGV s&apos;appliquent à toutes les ventes de services conclues par AD.NOVA.PRO auprès de consommateurs personnes physiques (B2C), notamment des sportifs professionnels et semi-professionnels souhaitant accéder au réseau privé Sport &amp; Business ou participer aux événements organisés.
        </p>
        <p>
          Les CGV priment sur toute autre condition générale, à l&apos;exception des conditions particulières expressément acceptées par écrit.
        </p>
      </Article>

      <Article num="3" title="Description des offres et tarifs">
        <p className="font-semibold text-white/80">3.1 — Abonnements au réseau privé</p>
        <p>AD.NOVA.PRO propose deux formules d&apos;accès au réseau Sport &amp; Business :</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-3">
          <div className="bg-[#080C1E] rounded-lg border border-white/[0.05] p-4">
            <p className="font-bold text-white/80 text-xs uppercase tracking-wide mb-2">Abonnement mensuel</p>
            <p className="text-[#C9A227] font-bold text-lg">Tarif en vigueur</p>
            <p className="text-white/40 text-xs mt-1">Renouvelable chaque mois · Résiliable à tout moment</p>
          </div>
          <div className="bg-[#080C1E] rounded-lg border border-white/[0.05] p-4">
            <p className="font-bold text-white/80 text-xs uppercase tracking-wide mb-2">Abonnement annuel</p>
            <p className="text-[#C9A227] font-bold text-lg">Tarif en vigueur</p>
            <p className="text-white/40 text-xs mt-1">Engagement 12 mois · Conditions de résiliation art. 9</p>
          </div>
        </div>
        <p className="text-white/40 text-xs mt-2">Les tarifs en vigueur sont affichés sur la page de souscription du site lereseausportif.com au moment de la commande.</p>

        <p className="font-semibold text-white/80 mt-4">3.2 — Billets d&apos;événements</p>
        <p>
          AD.NOVA.PRO organise ponctuellement des soirées networking privées à destination de ses membres et de candidats sélectionnés. Le prix par billet est indiqué sur la page de l&apos;événement concerné (ex. : 50 € par personne pour la soirée de lancement de mai 2026 à Bordeaux, dans la limite de 30 places).
        </p>

        <p className="font-semibold text-white/80 mt-4">3.3 — Franchise en base de TVA</p>
        <p>
          Madame Aurélie Pinto bénéficie de la franchise en base de TVA prévue à l&apos;article 293 B du Code général des impôts. <strong className="text-white/70">TVA non applicable — article 293 B du CGI.</strong> Les prix affichés sont donc des prix nets, sans TVA.
        </p>
      </Article>

      <Article num="4" title="Modalités de commande">
        <p>
          La commande est effectuée directement sur le site lereseausportif.com. Le processus de commande comprend les étapes suivantes :
        </p>
        <ol className="list-decimal list-inside space-y-2 text-white/60 pl-2">
          <li>Sélection de l&apos;offre ou du billet d&apos;événement</li>
          <li>Création ou connexion à un compte membre</li>
          <li>Récapitulatif de la commande et vérification des informations</li>
          <li>Acceptation des présentes CGV par case à cocher</li>
          <li>Paiement sécurisé en ligne</li>
          <li>Confirmation de commande par email</li>
        </ol>
        <p>
          La commande est ferme et définitive à compter de la validation du paiement et de la réception de la confirmation par email.
        </p>
      </Article>

      <Article num="5" title="Modalités de paiement">
        <p>
          Le paiement est effectué en ligne au moment de la commande par carte bancaire (Visa, Mastercard, CB) via un prestataire de paiement sécurisé.
        </p>
        <p>
          Les coordonnées bancaires du Client sont transmises directement au prestataire de paiement de manière cryptée. AD.NOVA.PRO ne conserve à aucun moment les données bancaires du Client.
        </p>
        <p>
          La transaction est considérée comme valide après confirmation du prestataire de paiement. En cas d&apos;échec du paiement, la commande est automatiquement annulée.
        </p>
      </Article>

      <Article num="6" title="Droit de rétractation">
        <p>
          Conformément aux articles L.221-18 et suivants du Code de la consommation, le Client consommateur dispose d&apos;un délai de rétractation de <strong className="text-white/80">14 jours calendaires</strong> à compter de la conclusion du contrat pour exercer son droit de rétractation, sans avoir à justifier de motifs ni à payer de pénalités.
        </p>
        <p className="font-semibold text-white/80">Exercice du droit de rétractation :</p>
        <p>
          Pour exercer ce droit, le Client notifie sa décision de rétractation par email à <a href="mailto:ad.nova.pro33@gmail.com" className="text-[#C9A227] hover:underline">ad.nova.pro33@gmail.com</a> en indiquant sa demande de manière claire et non ambiguë (ex. : « Je souhaite me rétracter du contrat souscrit le [date] »).
        </p>
        <p className="font-semibold text-white/80">Exceptions au droit de rétractation :</p>
        <p>
          Conformément à l&apos;article L.221-28 du Code de la consommation, le droit de rétractation ne s&apos;applique pas :
        </p>
        <ul className="list-disc list-inside space-y-1 text-white/60 pl-2">
          <li>Aux services pleinement exécutés avant la fin du délai de rétractation, si l&apos;exécution a commencé avec l&apos;accord exprès du Client (accès immédiat au réseau activé dès la souscription avec consentement exprès)</li>
          <li>Aux billets d&apos;événements dont la date est fixée (prestation de services de loisirs à une date ou période déterminée — article L.221-28, 12°)</li>
        </ul>
        <p>
          Dans les cas où l&apos;accès au réseau est immédiatement activé, le Client est expressément informé lors de la commande qu&apos;il renonce à son droit de rétractation en cochant la case prévue à cet effet.
        </p>
        <p className="font-semibold text-white/80">Remboursement en cas de rétractation valide :</p>
        <p>
          En cas de rétractation valide, AD.NOVA.PRO procède au remboursement de la totalité des sommes versées dans un délai de <strong className="text-white/70">14 jours</strong> à compter de la réception de la demande, par le même moyen de paiement que celui utilisé lors de la commande.
        </p>
      </Article>

      <Article num="7" title="Conditions d'annulation et de remboursement — Événements">
        <p className="font-semibold text-white/80">7.1 — Annulation par le Client</p>
        <p>
          Pour les billets d&apos;événements, le droit de rétractation de 14 jours ne s&apos;applique pas (voir article 6). Toutefois, les conditions suivantes s&apos;appliquent :
        </p>
        <ul className="list-disc list-inside space-y-1 text-white/60 pl-2">
          <li><strong className="text-white/70">Annulation à plus de 30 jours</strong> avant l&apos;événement : remboursement intégral du billet</li>
          <li><strong className="text-white/70">Annulation entre 15 et 30 jours</strong> avant l&apos;événement : remboursement de 50 % du billet</li>
          <li><strong className="text-white/70">Annulation à moins de 15 jours</strong> avant l&apos;événement : aucun remboursement</li>
        </ul>

        <p className="font-semibold text-white/80 mt-3">7.2 — Annulation par AD.NOVA.PRO</p>
        <p>
          En cas d&apos;annulation d&apos;un événement par AD.NOVA.PRO pour raison de force majeure ou pour des motifs indépendants de sa volonté, le Client sera remboursé intégralement du prix du billet dans un délai de 14 jours. AD.NOVA.PRO ne pourra être tenu responsable de frais annexes engagés par le Client (transport, hébergement…).
        </p>

        <p className="font-semibold text-white/80 mt-3">7.3 — Abonnements</p>
        <p>
          Le remboursement d&apos;un abonnement est possible dans le cadre du droit de rétractation de 14 jours mentionné à l&apos;article 6. Passé ce délai, aucun remboursement ne sera effectué pour la période en cours. La résiliation prend effet à la fin de la période en cours (voir article 9).
        </p>
      </Article>

      <Article num="8" title="Accès aux services — Durée des abonnements">
        <p>
          L&apos;accès au réseau privé AD.NOVA.PRO est conditionné à la souscription d&apos;un abonnement actif et au respect des présentes CGV ainsi que des Conditions Générales d&apos;Utilisation (CGU) du site.
        </p>
        <p>
          <strong className="text-white/80">Abonnement mensuel :</strong> le contrat prend effet à compter de la validation du paiement et se renouvelle automatiquement chaque mois, à la même date, par tacite reconduction.
        </p>
        <p>
          <strong className="text-white/80">Abonnement annuel :</strong> le contrat est conclu pour une durée de douze (12) mois à compter de la date de souscription. Il se renouvelle tacitement pour une nouvelle période d&apos;un an, sauf résiliation dans les conditions prévues à l&apos;article 9.
        </p>
      </Article>

      <Article num="9" title="Résiliation des abonnements">
        <p>
          Le Client peut résilier son abonnement à tout moment depuis son espace personnel sur lereseausportif.com ou par email à <a href="mailto:ad.nova.pro33@gmail.com" className="text-[#C9A227] hover:underline">ad.nova.pro33@gmail.com</a>.
        </p>
        <p>
          La résiliation prend effet à la fin de la période d&apos;abonnement en cours (mensuelle ou annuelle). Aucun prorata temporis ne sera remboursé pour la période restante.
        </p>
        <p>
          Pour les abonnements annuels, la demande de résiliation doit être transmise au moins <strong className="text-white/70">30 jours avant la date de renouvellement</strong> pour éviter le déclenchement d&apos;une nouvelle période annuelle facturée.
        </p>
        <p>
          AD.NOVA.PRO se réserve le droit de résilier un abonnement sans remboursement en cas de manquement grave aux CGU (comportement inapproprié, violation des règles de la communauté, utilisation frauduleuse…), après mise en demeure restée sans effet.
        </p>
      </Article>

      <Article num="10" title="Clause de résultats — Accompagnement">
        <p>
          AD.NOVA.PRO propose un réseau d&apos;entraide, de mise en relation et un accompagnement structuré à la reconversion professionnelle. Le Client reconnaît et accepte expressément que :
        </p>
        <ul className="list-disc list-inside space-y-1 text-white/60 pl-2">
          <li>AD.NOVA.PRO est tenue à une <strong className="text-white/70">obligation de moyens</strong> et non à une obligation de résultat</li>
          <li>Aucun résultat spécifique (financier, professionnel ou autre) n&apos;est garanti</li>
          <li>La réussite de la reconversion dépend notamment de l&apos;implication du Client, de son profil, de son projet et des conditions de marché</li>
          <li>Les témoignages et retours d&apos;expérience présentés sur le site sont des cas individuels et ne constituent pas une promesse de résultats identiques</li>
        </ul>
      </Article>

      <Article num="11" title="Propriété intellectuelle">
        <p>
          L&apos;ensemble des contenus accessibles sur la plateforme lereseausportif.com (textes, visuels, ressources, présentations, méthodologies, guides…) est la propriété intellectuelle exclusive d&apos;AD.NOVA.PRO ou de ses partenaires.
        </p>
        <p>
          L&apos;abonnement confère au Client un droit d&apos;accès et d&apos;usage personnel et non commercial des contenus. Toute reproduction, redistribution, revente ou exploitation commerciale est strictement interdite sans autorisation écrite préalable.
        </p>
      </Article>

      <Article num="12" title="Protection des données personnelles">
        <p>
          Les données personnelles collectées lors de la commande sont traitées conformément au RGPD et à la politique de confidentialité d&apos;AD.NOVA.PRO. Elles sont utilisées exclusivement pour la gestion de la relation contractuelle, l&apos;accès aux services et, si consentement, à des fins de communication.
        </p>
        <p>
          Responsable du traitement : Madame Aurélie Pinto — <a href="mailto:ad.nova.pro33@gmail.com" className="text-[#C9A227] hover:underline">ad.nova.pro33@gmail.com</a>
        </p>
      </Article>

      <Article num="13" title="Médiation de la consommation">
        <p>
          Conformément aux articles L.616-1 et R.616-1 du Code de la consommation, AD.NOVA.PRO a adhéré à un dispositif de médiation de la consommation.
        </p>
        <p>
          En cas de litige non résolu à l&apos;amiable entre AD.NOVA.PRO et un Client consommateur, ce dernier peut recourir gratuitement à un médiateur de la consommation.
        </p>
        <div className="bg-[#080C1E] rounded-lg border border-[#C9A227]/20 p-4 mt-2">
          <p className="text-white/40 text-xs">
            <strong className="text-white/60">Médiateur compétent :</strong> [Nom et coordonnées du médiateur à compléter lors de l&apos;adhésion au dispositif de médiation — ex. : Association Nationale des Médiateurs (ANM), Médiation Tourisme et Voyage selon les cas]<br />
            Site de la Commission européenne pour le règlement en ligne des litiges (RLL) : <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="nofollow noopener noreferrer" className="text-[#C9A227] hover:underline">ec.europa.eu/consumers/odr</a>
          </p>
        </div>
        <p>
          Le recours à la médiation est ouvert dans un délai d&apos;un an à compter de la réclamation écrite adressée à AD.NOVA.PRO. Cette démarche est sans préjudice des voies de recours judiciaires.
        </p>
      </Article>

      <Article num="14" title="Droit applicable — Juridiction compétente">
        <p>
          Les présentes CGV sont régies par le droit français.
        </p>
        <p>
          En cas de litige, le Client est invité à contacter AD.NOVA.PRO pour tenter une résolution amiable. À défaut, la juridiction compétente sera le <strong className="text-white/80">Tribunal judiciaire de Bordeaux</strong>, sous réserve des dispositions d&apos;ordre public applicables aux consommateurs (notamment l&apos;article L.141-5 du Code de la consommation permettant au consommateur de saisir la juridiction du lieu où il demeurait).
        </p>
      </Article>

      <Article num="15" title="Mise à jour des CGV">
        <p>
          AD.NOVA.PRO se réserve le droit de modifier les présentes CGV à tout moment. Les CGV applicables sont celles en vigueur au jour de la commande, accessibles et archivées sur lereseausportif.com.
        </p>
        <p>
          En cas de modification substantielle affectant les abonnements en cours, le Client sera informé par email avec un préavis de 30 jours minimum et pourra résilier son abonnement sans frais.
        </p>
      </Article>

      <div className="mt-12 pt-8 border-t border-white/[0.07] text-center">
        <p className="text-xs text-white/25">CGV entrées en vigueur le 27 janvier 2026 — Dernière mise à jour : mars 2026 — lereseausportif.com</p>
      </div>
    </LegalLayout>
  );
}
